import {
  API_URL,
  store
} from '../index'
import axios from 'axios/index'

/* import error handler */
import ErrorHandler from '../ErrorHandler'
import SuccessHandler from '../SuccessHandler'

/* private InvoicePositions Types */
import {
  _InvoicePosition
} from '../namespace-helper'

import _ from 'lodash'

const selectedInvoicePositionTemplate = {
  id: 0,
  product: {
    id: 0,
    reference: null,
    product_description: {},
    manufacturer: {
      name: null
    }
  },
  delivery_time: {},
  discounts: [],
  unit_price: '0,00',
  suppliers_offer: {
    currency: {
      name: ''
    }
  }

}
export default {
  namespaced: true,
  state: {
    selectedInvoicePosition: _.cloneDeep(selectedInvoicePositionTemplate),
    invoicePositions: [],
    invoicePositionLoading: false,
    invoicePositionRemoving: false,
    openDialog: false
  },
  mutations: {
    [_InvoicePosition.mutations.setSelectedInvoicePosition] (state, payload) {
      if (payload !== null) {
        state.selectedInvoicePosition = payload
      } else {
        state.selectedInvoicePosition = _.cloneDeep(selectedInvoicePositionTemplate)
      }
    },
    [_InvoicePosition.mutations.setInvoicePositions] (state, payload) {
      state.invoicePositions = payload
    },
    [_InvoicePosition.mutations.setRemovingInvoicePosition] (state, payload) {
      state.setRemovingInvoicePosition = payload
    },
    [_InvoicePosition.mutations.setOpenCloseDialogState] (state) {
      state.openDialog = !state.openDialog
    }
  },
  actions: {
    [_InvoicePosition.actions.saveInvoicePosition] (context, payload) {
      const data = JSON.stringify(payload)

      return new Promise((resolve, reject) => {
        if (payload.id === 0) {
          var url = API_URL + '/api/v1/invoicePositions'

          axios.post(url, data, {
            headers: {
              'Content-Type': 'application/json',
              Authorization: 'Bearer ' + store.getters.getBearerToken
            }
          }
          ).then(function (r) {
            ErrorHandler.clear(store)
            SuccessHandler.handleApiSuccess(store, r.data.message)
            resolve(r)
          }, function (err) {
            ErrorHandler.handleApiError(store, err)
            reject(err)
          }).catch(e => console.error('#### ' + e))
        } else {
          url = API_URL + '/api/v1/invoicePositions/' + payload.id

          axios.put(url, data, {
            headers: {
              'Content-Type': 'application/json',
              Authorization: 'Bearer ' + store.getters.getBearerToken
            }
          }
          ).then(function (r) {
            ErrorHandler.clear(store)
            SuccessHandler.handleApiSuccess(store, r.data.message)
            resolve(r)
          }, function (err) {
            ErrorHandler.handleApiError(store, err)
            reject(err)
          }).catch(e => console.error('#### ' + e))
        }
      })
    },
    [_InvoicePosition.actions.loadInvoicePositionForInvoice] (context, payload) {
      var url = API_URL + '/api/v1/invoicePositions/invoice/' + payload.id

      return new Promise((resolve, reject) => {
        axios.get(url, {
          headers: {
            'Content-Type': 'application/json',
            Authorization: 'Bearer ' + store.getters.getBearerToken
          }
        }
        ).then(function (r) {
          ErrorHandler.clear(store)
          context.commit(_InvoicePosition.mutations.setInvoicePositions, r.data.data)
          resolve(r)
        }, function (err) {
          context.commit(_InvoicePosition.mutations.setInvoicePositions, null)
          ErrorHandler.handleApiError(store, err)
          reject(err)
        }).catch(e => console.error('#### ' + e))
      })
    },
    [_InvoicePosition.actions.confirmInvoicePosition] (context, payload) {
      var url = API_URL + '/api/v1/invoicePositions/confirm/' + payload.id

      return new Promise((resolve, reject) => {
        axios.get(url, {
          headers: {
            'Content-Type': 'application/json',
            Authorization: 'Bearer ' + store.getters.getBearerToken
          }
        }
        ).then(function (r) {
          ErrorHandler.clear(store)
          resolve(r)
        }, function (err) {
          ErrorHandler.handleApiError(store, err)
          reject(err)
        }).catch(e => console.error('#### ' + e))
      })
    },
    [_InvoicePosition.actions.deleteInvoicePosition] (context, payload) {
      context.commit(_InvoicePosition.mutations.setRemovingInvoicePosition, true)

      var url = API_URL + '/api/v1/invoicePositions/' + payload.id

      return new Promise((resolve, reject) => {
        axios.delete(url, {
          headers: {
            'Content-Type': 'application/json',
            Authorization: 'Bearer ' + store.getters.getBearerToken
          }
        }
        ).then(function (r) {
          context.commit(_InvoicePosition.mutations.setRemovingInvoicePosition, false)
          ErrorHandler.clear(store)
          SuccessHandler.handleApiSuccess(store, r.data.message)
          resolve(r)
        }, function (err) {
          context.commit(_InvoicePosition.mutations.setRemovingInvoicePosition, false)
          ErrorHandler.handleApiError(store, err)
          reject(err)
        }).catch(e => console.error('#### ' + e))
      })
    },
    [_InvoicePosition.actions.setSelectedInvoicePosition] (context, payload) {
      context.commit(_InvoicePosition.mutations.setSelectedInvoicePosition, payload)
    },
    [_InvoicePosition.actions.clearInvoicePositions] (context, payload) {
      context.commit(_InvoicePosition.mutations.setInvoicePositions, [])
    },
    [_InvoicePosition.actions.openCloseDialog] ({ commit }) {
      commit(_InvoicePosition.mutations.setOpenCloseDialogState)
    },
    [_InvoicePosition.actions.resetState] (context, payload) {
      context.commit(_InvoicePosition.mutations.setInvoicePositions, [])
      context.commit(_InvoicePosition.mutations.setSelectedInvoicePosition, null)
    }

  },
  getters: {
    [_InvoicePosition.getters.invoicePositions] (state) {
      return state.invoicePositions
    },
    [_InvoicePosition.getters.getSelectedInvoicePosition] (state) {
      return state.selectedInvoicePosition
    },
    [_InvoicePosition.getters.getOpenDialogState] (state) {
      return state.openDialog
    }

  }
}



// WEBPACK FOOTER //
// ./src/store/InvoicePosition/invoicePositions.js